import { render, staticRenderFns } from "./PracticesManager.vue?vue&type=template&id=6c16c747"
import script from "./PracticesManager.vue?vue&type=script&lang=js"
export * from "./PracticesManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports